<template>
  <footer class="bg-gray-800 text-white py-12">
    <div class="container mx-auto px-6">
      <!-- 顶部内容区 -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
        <!-- 品牌信息 -->
        <div>
          <h3 class="text-xl font-bold mb-4 text-white">VISION</h3>
          <p class="text-gray-400 mb-4">
            To become the preferred partner for damping and sound insulation felt across global construction and
            industrial sectors.
            Mission：Create tailored acoustic solutions that maximize value for customers with cutting-edge technology
            and reliable service.
          </p>
          <div class="flex space-x-4">
            <!-- Facebook -->
            <a href="https://www.facebook.com/profile.php?id=61583904754569" target="_blank" rel="noopener"
              class="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
              <i class="fa fa-facebook text-xl"></i>
            </a>
            <!-- YouTube -->
            <a href="https://www.youtube.com/@%E9%BB%84%E4%BC%9F-b7x" target="_blank" rel="noopener"
              class="text-gray-400 hover:text-white transition-colors" aria-label="YouTube">
              <i class="fa fa-youtube-play text-xl"></i>
            </a>
            <!-- TikTok -->
            <a href="https://www.tiktok.com/@zzhuangwei" target="_blank" rel="noopener"
              class="text-gray-400 hover:text-white transition-colors flex items-center justify-center w-8 h-8 text-xl"
              aria-label="TikTok" style="height: 24px;">
              <span class="icon iconfont icon-Vector"></span>
            </a>

            <!-- X (Twitter) -->
            <a href="https://x.com/huangwei8ibm" target="_blank" rel="noopener"
              class="text-gray-400 hover:text-white transition-colors" aria-label="X (Twitter)">
              <i class="fa fa-twitter text-xl"></i>
            </a>
          </div>
        </div>
        <!-- 热门产品 -->
        <div>
          <h4 class="text-lg font-semibold mb-4 text-white">PRODUCTS</h4>
          <ul class="space-y-2">
            <li v-for="item in productList" :key="item.id">
              <router-link :to="`/products/${item.id}`" class="text-gray-400 hover:text-white transition-colors">
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- 联系信息 -->
        <div>
          <h4 class="text-lg font-semibold mb-4 text-white">Contact Info</h4>
          <ul class="space-y-3 text-gray-400">
            <li class="flex items-start">
              <i class="fa fa-map-marker mt-1 mr-3 text-primary"></i>
              <span>{{ set.address || 'No address provided' }}</span>
            </li>
            <li class="flex items-center">
              <i class="fa fa-phone mr-3 text-primary"></i>
              <a :href="`tel:${set.linkPhone}`" class="hover:text-white transition-colors">
                {{ set.linkPhone || 'No phone number provided' }}
              </a>
            </li>
            <li class="flex items-center">
              <i class="fa fa-envelope mr-3 text-primary"></i>
              <a :href="`mailto:${set.email}`" class="hover:text-white transition-colors">
                {{ set.email || 'No email provided' }}
              </a>
            </li>
            <li class="flex items-center">
              <i class="fa fa-clock-o mr-3 text-primary"></i>
              <span>{{ set.workTime || 'No business hours provided' }}</span>
            </li>
          </ul>
        </div>
        <!-- 新闻 -->
        <div>
          <h4 class="text-lg font-semibold mb-4 text-white">NEWS</h4>
          <ul class="space-y-2">
            <li v-for="(news, index) in newsData" :key="index">
              <router-link :to="{
                name: 'NewsDetail',
                params: { NewsId: news.id }
              }" class="text-gray-400 hover:text-white transition-colors">
                {{ news.title }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- 留言表单（对接接口） -->
      <div class="bg-gray-700 rounded-lg p-6 mb-8">
        <h4 class="text-lg font-semibold mb-4 text-white">CONTACT US</h4>
        <form class="grid grid-cols-1 md:grid-cols-3 gap-4" @submit.prevent="handleFooterFormSubmit">
          <div>
            <input type="text" placeholder="Your Name"
              class="w-full px-4 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              v-model="footerForm.nickName" :disabled="isSubmitting" required>
          </div>
          <div>
            <input type="email" placeholder="Your Email"
              class="w-full px-4 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              v-model="footerForm.email" :disabled="isSubmitting" required>
          </div>
          <div>
            <input type="tel" placeholder="Tel:+(area code)"
              class="w-full px-4 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              v-model="footerForm.linkPhone" :disabled="isSubmitting" required>
          </div>
          <div class="md:col-span-3">
            <textarea placeholder="Your Message" rows="3"
              class="w-full px-4 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              v-model="footerForm.messageContent" :disabled="isSubmitting" required></textarea>
          </div>
          <div class="md:col-span-3 text-right">
            <button type="submit"
              class="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
              :disabled="isSubmitting">
              <i v-if="isSubmitting" class="fa fa-spinner fa-spin mr-2"></i>
              SEND MESSAGE
            </button>
          </div>
        </form>
      </div>

      <!-- 版权信息 -->
      <div class="border-t border-gray-700 pt-6 text-center text-gray-500 text-sm">
        <p>©1997-2025 ONLY IMGING. ALL RIGHTS RESERVED
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue'
import { listIndexProduct, indexSet } from '@/api/index'
import { pageNews } from '@/api/news'
import { messageSubmit } from '@/api/message' // 导入留言接口
// 如需使用 Element Plus 消息提示则导入（没有则用 alert）
// import { ElMessage } from 'element-plus'

// 产品列表
const productList = ref([])
// 站点配置
const set = ref({})
// 新闻列表
const newsData = ref([])
// 表单提交状态
const isSubmitting = ref(false)
// 底部表单数据（对应接口字段）
const footerForm = reactive({
  nickName: '',     // 姓名
  email: '',        // 邮箱
  linkPhone: '',    // 联系方式
  messageContent: ''// 留言内容
})

// 获取首页产品列表
const getListIndexProduct = async () => {
  try {
    let res = await listIndexProduct()
    productList.value = res.data || []
  } catch (error) {
    console.error('获取产品列表失败:', error)
  }
}

// 获取站点配置
const getIndexSet = async () => {
  try {
    let res = await indexSet()
    set.value = res.data || {}
  } catch (error) {
    console.error('获取站点配置失败:', error)
  }
}

// 获取新闻列表
const getListNews = async () => {
  try {
    let res = await pageNews({
      pubStatus: 2,
      currentPage: 1,
      pageSize: 3
    })
    newsData.value = res.rows || []
  } catch (error) {
    console.error('获取新闻列表失败:', error)
    newsData.value = []
  }
}

// 底部表单提交处理
const handleFooterFormSubmit = async () => {
  // 简单校验（必填项）
  if (!footerForm.nickName.trim()) {
    alert('Please enter your name!') // 替换为 ElMessage.error 更美观
    return
  }
  if (!footerForm.email.trim()) {
    alert('Please enter a valid email address!')
    return
  }
  if (!footerForm.linkPhone.trim()) {
    alert('Please enter your phone number!')
    return
  }
  if (!footerForm.messageContent.trim()) {
    alert('Please enter your message!')
    return
  }

  try {
    isSubmitting.value = true
    // 调用留言接口
    const res = await messageSubmit(footerForm)

    // 接口返回成功处理
    if (res.code === 200 || res.success) {
      // ElMessage.success('Message sent successfully!')
      alert('Your message has been sent successfully! We will respond within 24 hours.')
      // 重置表单
      footerForm.nickName = ''
      footerForm.email = ''
      footerForm.linkPhone = ''
      footerForm.messageContent = ''
    } else {
      // ElMessage.error(res.msg || 'Failed to send message')
      alert(res.msg || 'Sorry, there was an error sending your message. Please try again later.')
    }
  } catch (error) {
    console.error('表单提交失败:', error)
    // ElMessage.error('Failed to send message, please try again')
    alert('Sorry, there was an error submitting your form. Please try again later.')
  } finally {
    isSubmitting.value = false
  }
}

// 页面挂载时加载数据
onMounted(() => {
  getListIndexProduct()
  getIndexSet()
  getListNews()
})
</script>

<style scoped>
/* 表单聚焦样式优化 */
input:focus,
textarea:focus {
  border-color: var(--tw-ring-color);
}

/* 禁用状态样式 */
input:disabled,
textarea:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>